import type { LeaveBalanceLine } from "@/api/types";
import { Meter } from "@/components/charts";
import { formatDays, formatTimestampDate } from "@/lib/format";
import { leaveLabel } from "@/lib/labels";

/**
 * One leave balance line, as every balance screen shows it.
 *
 * The meter reads "used / total". That is enough while the total is a policy
 * entitlement everyone knows, but once HR has stated a balance by hand the total
 * is HR's number, and the person looking needs to be told both that, and how
 * much of it is left — so the line says so rather than leaving them to subtract.
 */
export function LeaveBalanceMeter({ type, line }: { type: string; line: LeaveBalanceLine }) {
  return (
    <div className="flex flex-col gap-1">
      <Meter
        label={leaveLabel(type)}
        used={line.taken}
        total={line.entitlement ?? 0}
        /* Comp Off's total is days earned, not a cap — spending it all is not a
           state worth colouring red. */
        escalate={type !== "CompOff"}
      />
      {line.setByHr && (
        <p className="text-xs leading-relaxed text-muted">
          {formatDays(line.available)} left · set by {line.setByHr.setByName ?? "HR"} on{" "}
          {formatTimestampDate(line.setByHr.setAt, "d MMM yyyy")}
        </p>
      )}
    </div>
  );
}
